import React from 'react';
import { Collapse } from 'antd';
import { IQuoteLineItem } from '../../types';
import { IDealersCurrency } from '@/types';
import { formatDealerAmount } from '@/utils/currency';
import { WindowConfigurationDisplay } from './WindowConfigurationDisplay';
import { useGetSubQuoteProducts } from '../../hooks';
import { getEgressBadgeFromSubProducts } from './detail-shared/helpers';
import { FireEgressBadge } from '@/features/assistant/components/FireEgressBadge';

const EgressBadgeLoader: React.FC<{ quotedetailid: string }> = ({ quotedetailid }) => {
  const { data } = useGetSubQuoteProducts(quotedetailid);
  const subs = data?.value ?? [];
  const status = getEgressBadgeFromSubProducts(subs);
  if (!status) return null;
  return <FireEgressBadge status={status} />;
};

interface QuoteWindowSectionProps {
  lineItems: IQuoteLineItem[];
  dealersCurrency?: IDealersCurrency | null;
  exchangeRate?: number;
}

export const QuoteWindowSection: React.FC<QuoteWindowSectionProps> = ({
  lineItems,
  dealersCurrency,
  exchangeRate,
}) => {
  if (lineItems.length === 0) return null;

  const formatAmount = (amount: number) =>
    formatDealerAmount(amount, dealersCurrency, exchangeRate);

  return (
    <div className="bg-white rounded-lg p-6">
      <h3 className="text-lg font-semibold text-left text-gray-900 mb-4">
        Window Configuration
      </h3>
      <Collapse
        className="mb-4"
        defaultActiveKey={lineItems.map((item) => item.quotedetailid)}
      >
        {lineItems.map((lineItem, index) => (
          <Collapse.Panel
            key={lineItem.quotedetailid}
            header={
              <div className="flex items-center justify-between w-full pr-2">
                <span className="font-semibold text-left text-gray-900">
                  {lineItem.dogma_windowname || lineItem.productname || `Frame ${index + 1}`}
                </span>
                <span className="text-sm text-gray-500 font-medium">
                  Qty: {lineItem.quantity ?? 1}
                </span>
              </div>
            }
          >
            <EgressBadgeLoader quotedetailid={lineItem.quotedetailid} />
            <WindowConfigurationDisplay
              quoteProductId={lineItem.quotedetailid}
              subtotal={lineItem.dogma_vsssubtotal ?? 0}
              dealersCurrency={dealersCurrency ?? undefined}
              exchangeRate={exchangeRate}
            />
            <div className="mt-4 pt-3 border-t border-gray-200 flex justify-between items-center">
              <span className="text-sm text-gray-600">Window Subtotal</span>
              <span className="text-base font-bold text-gray-900">
                {formatAmount(lineItem.dogma_vsssubtotal ?? 0)}
              </span>
            </div>
          </Collapse.Panel>
        ))}
      </Collapse>
    </div>
  );
};
